import loadable from "@loadable/component";

export const MansionCustomerConfigureList = loadable(() => import("./list-mansion"));
export const ShareOfficeCustomerConfigureList = loadable(() => import("./list-shareoffice"));

export const NotificationSetting = loadable(() => import("./notification-setting"));
